.project-avatar-wrapper {
  padding-right: 1.6rem !important;

  img {
    position: relative;
    width: 5.6rem;
    height: 3.2rem;
    border-radius: 0.2rem;
  }
}

.last-cell-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 4.8rem;
}

.styled-list-view-item {
  opacity: 1;
  transition: opacity 0.2s ease;

  &[data-archived='true'] {
    opacity: 0.6;
  }
}

.archived-label {
  color: #ffa500;
  font-style: italic;
  font-size: 1.2rem;
}
